import React, { useState } from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';
import userPool from './Userpool';
import PortalHeader from './PortalHeader';
import ResetPasswordForm from './ResetPasswordForm';
import { checkCognitoUserExists } from '../api/checkUserExists';
import './styles/Login.css';

const ResetPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [step, setStep] = useState('request'); // 'request' or 'reset'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  const [resetError, setResetError] = useState('');

  const handleRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    // Check if user exists in Cognito before proceeding
    const exists = await checkCognitoUserExists(email);
    if (!exists) {
      setError('No account found with this email address.');
      setLoading(false);
      return;
    }
    const user = new CognitoUser({ Username: email, Pool: userPool });
    user.forgotPassword({
      onSuccess: () => {
        setStep('reset');
        setLoading(false);
      },
      onFailure: (err) => {
        setError(err.message || 'Failed to send reset code');
        setLoading(false);
      },
    });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setResetLoading(true);
    setResetError('');
    const code = e.target.code.value;
    const newPassword = e.target.newPassword.value;
    const user = new CognitoUser({ Username: email, Pool: userPool });
    user.confirmPassword(code, newPassword, {
      onSuccess: () => {
        setStep('done');
        setResetLoading(false);
      },
      onFailure: (err) => {
        setResetError(err.message || 'Failed to reset password');
        setResetLoading(false);
      },
    });
  };

  return (
    <div className="login-container">
      <PortalHeader />
      <div className="background-animation"></div>
      <div className="login-card">
        <div className="login-header">
          <i className="fas fa-lock login-icon"></i>
          <h2>Reset Password</h2>
          <p>Enter your email to receive a reset code.</p>
        </div>
        {step === 'request' && (
          <form className="login-form" onSubmit={handleRequest}>
            {error && <div className="error-message">{error}</div>}
            <div className="input-group">
              <label htmlFor="resetEmail">Email</label>
              <input
                type="email"
                id="resetEmail"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
              />
            </div>
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Code'}
            </button>
          </form>
        )}
        {step === 'reset' && (
          <ResetPasswordForm
            onReset={handleReset}
            email={email}
            loading={resetLoading}
            error={resetError}
          />
        )}
        {step === 'done' && (
          <div className="success-message">
            Password reset successful! You can now <a href="/">log in</a>.
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
